import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class UserListView {
  userId: string = ""
  spaceUserId: string = ""
  firstname: string = ""
  lastname: string = ""
  name?: string
  email: string = ""
  phone: string = ""
  title: string = ""
  roles: string[] = []

  constructor(
    data: {
      userId: string
      spaceUserId: string
      firstname: string
      lastname: string
      name?: string
      email: string
      phone?: string
      title?: string
      roles: string[]
    } | null = null,
  ) {
    if (data) {
      this.userId = data.userId
      this.spaceUserId = data.spaceUserId
      this.firstname = data.firstname
      this.lastname = data.lastname
      this.name = data.name
      this.email = data.email
      this.phone = data.phone || ""
      this.title = data.title || ""
      this.roles = data.roles
    }
  }
}
